(() => {
  'use strict';
  function mount(gallery) {
    if (gallery.dataset.galleryReady) return;
    gallery.dataset.galleryReady = 'true';
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const status = gallery.querySelector('[data-gallery-status]');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0, scheduled = false;
    function pause(slide) {
      slide.querySelectorAll('video').forEach(video => video.pause());
      const external = slide.querySelector('[data-external-media]');
      if (external?.querySelector('iframe')) {
        external.querySelector('iframe').remove();
        external.querySelector('[data-load-external]').hidden = false;
      }
    }
    function update(index) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, i) => {
        slide.inert = i !== active;
        slide.setAttribute('aria-hidden', String(i !== active));
        if (i !== active) pause(slide);
      });
      thumbs.forEach((thumb, i) => { if (i === active) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current'); });
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
      if (status) status.textContent = `${active + 1} / ${slides.length}`;
      gallery.dataset.activeMedia = slides[active]?.dataset.mediaId || 'cover';
      const thumb = thumbs[active], rail = gallery.querySelector('[data-gallery-thumbs]');
      if (thumb && rail) {
        const left = thumb.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft || left + thumb.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({left:Math.max(0,left - (rail.clientWidth-thumb.offsetWidth)/2),behavior:reduce.matches?'auto':'smooth'});
      }
    }
    function go(index) {
      const selected = Math.max(0, Math.min(slides.length - 1, index));
      update(selected);
      track.scrollTo({left:track.clientWidth * selected,behavior:reduce.matches?'auto':'smooth'});
    }
    thumbs.forEach((thumb,i) => thumb.addEventListener('click',event => {event.preventDefault();go(i);}));
    previous?.addEventListener('click',() => go(active-1)); next?.addEventListener('click',() => go(active+1));
    track.addEventListener('keydown',event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft') {event.preventDefault();go(active-1);}
      if (event.key === 'ArrowRight') {event.preventDefault();go(active+1);}
      if (event.key === 'Home') {event.preventDefault();go(0);}
      if (event.key === 'End') {event.preventDefault();go(slides.length-1);}
    });
    track.addEventListener('scroll',() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {scheduled=false; const index=Math.round(track.scrollLeft/track.clientWidth);if(index!==active)update(index);});
    },{passive:true});
    gallery.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
    gallery.querySelectorAll('[data-load-external]').forEach(button => button.addEventListener('click',() => {
      const parent=button.closest('[data-external-media]');parent.append(parent.querySelector('template').content.cloneNode(true));button.hidden=true;parent.querySelector('iframe')?.focus();
    }));
    gallery.addEventListener('play',event => {slides.forEach(slide => {slide.querySelectorAll('video').forEach(video => {if(video!==event.target)video.pause();});});},true);
    document.addEventListener('visibilitychange',() => {if(document.hidden)slides.forEach(pause);});
    const variants=JSON.parse(gallery.querySelector('[data-gallery-variants]').textContent);
    document.querySelector('[data-variant-select]')?.addEventListener('change',event => {
      const index=slides.findIndex(slide=>slide.dataset.mediaId===String(variants[event.target.value]));if(index>=0)go(index);
    });
    new ResizeObserver(() => {track.scrollTo({left:track.clientWidth*active,behavior:'instant'});}).observe(track);
    const hashIndex=slides.findIndex(slide=>'#'+slide.id===location.hash);update(hashIndex>=0?hashIndex:0);
  }
  document.querySelectorAll('[data-product-gallery]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-product-gallery]').forEach(mount));
})();
